import { createReducer } from '../lib/createReducer';

const initialState = {
  operationsMetrics: [],
  companiesWithWorkflows: [],
  apiCalls: [],
  workflowOperations: [],
  workflowCompanyUsage: [],
  workflowCompanyUsageError: null,
  workflowAlarms: [],
  hubspotCompanyMappings: {
    hubspotCompanies: [],
    gravityCompanies: []
  },
  hubspotCompanyMappingsError: null
};

const setWorkflowAlarms = (state, payload) => ({
  ...state,
  workflowAlarms: payload?.data || []
});

export default createReducer(initialState, {
  GET_OPERATION_METRICS_SUCCESS: (state, payload) => ({
    ...state,
    operationsMetrics: payload?.data || []
  }),
  GET_COMPANIES_WITH_WORKFLOWS_SUCCESS: (state, payload) => ({
    ...state,
    companiesWithWorkflows: payload?.data || []
  }),
  GET_API_CALLS_SUCCESS: (state, payload) => ({
    ...state,
    apiCalls: payload?.data || []
  }),
  GET_WORKFLOW_OPERATIONS_SUCCESS: (state, payload) => ({
    ...state,
    workflowOperations: payload?.data || []
  }),
  GET_WORKFLOW_COMPANY_USAGE_SUCCESS: (state, payload) => ({
    ...state,
    workflowCompanyUsage: payload?.data || [],
    workflowCompanyUsageError: null
  }),
  GET_WORKFLOW_COMPANY_USAGE_FAIL: (state, payload) => ({
    ...state,
    workflowCompanyUsageError: payload?.message || 'Failed to load workflow company usage.'
  }),
  GET_WORKFLOW_ALARMS_SUCCESS: setWorkflowAlarms,
  GET_HUBSPOT_COMPANY_MAPPINGS_SUCCESS: (state, payload) => ({
    ...state,
    hubspotCompanyMappings: payload?.data || { hubspotCompanies: [], gravityCompanies: [] },
    hubspotCompanyMappingsError: null
  }),
  GET_HUBSPOT_COMPANY_MAPPINGS_FAIL: (state, payload) => ({
    ...state,
    hubspotCompanyMappingsError: payload?.data?.message || payload?.message || 'HubSpot companies could not be loaded.'
  }),
  UPDATE_HUBSPOT_COMPANY_MAPPING_SUCCESS: (state, payload) => ({
    ...state,
    hubspotCompanyMappings: {
      ...state.hubspotCompanyMappings,
      hubspotCompanies: state.hubspotCompanyMappings.hubspotCompanies.map((company) =>
        company.hubspotCompanyId === payload?.data?.hubspotCompanyId
          ? {
              ...company,
              companyId: payload?.data?.companyId ?? null
            }
          : company
      )
    }
  }),
  SET_WORKFLOW_ALARMS_SUCCESS: setWorkflowAlarms,
  ENABLE_WORKFLOW_ALARM_SUCCESS: (state, payload) => ({
    ...state,
    workflowAlarms: state.workflowAlarms.some((alarm) => alarm.workflowId === payload?.data?.workflowId) ? state.workflowAlarms : [...state.workflowAlarms, { workflowId: payload?.data?.workflowId, sensitivity: 'sustained', alarmState: 'ok' }]
  }),
  DISABLE_WORKFLOW_ALARM_SUCCESS: (state, payload) => ({
    ...state,
    workflowAlarms: state.workflowAlarms.filter((alarm) => alarm.workflowId !== payload?.data?.workflowId)
  })
});
